module.exports = __webpack_public_path__ + "static/img/20.d95d2d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/20.png
// module id = Sp5t
// module chunks = 0